import Barcode from "react-barcode";
import QRCode from 'react-qr-code';

export const SpacingDiv = () => <div style={{ width: '2in', height: '1in' }} />;
// barcode
// export const BarCodeDiv = ({ value, shortCode }) => (
//   <div
//     style={{
//       width: '2in',
//       height: '1in',
//       position: 'relative',
//       fontFamily: 'Arial, sans-serif',
//       boxSizing: 'border-box',
//       padding: '0.05in',
//       marginRight: '0.4in', // <-- adds horizontal space between barcodes
//       display: 'inline-block', // <-- ensures divs align side-by-side
//     }}
//   >
//     <div
//       style={{
//         width: '100%',
//         height: '100%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'flex-start',
//         alignItems: 'center',
//       }}
//     >
//       <Barcode value={shortCode} format='CODE128' width={1.9} height={40} margin={4} fontSize={10} displayValue={false} />
//       <p style={{ fontSize: '6pt', margin: '3px 0 4px', lineHeight: '1.2' }}>{value}</p>
//       <div
//         style={{
//           width: '100%',
//           paddingLeft: '0.2in',
//           fontSize: '5pt',
//           fontWeight: 700,
//           color: 'black',
//           lineHeight: '1.2',
//         }}
//       >
//         {['Full Name:', 'Col. Date:', 'DOB:'].map((label, i) => (
//           <div
//             key={i}
//             style={{
//               display: 'flex',
//               justifyContent: 'flex-start',
//               alignItems: 'baseline',
//               whiteSpace: 'nowrap',
//               marginBottom: '1px',
//               gap: '4px',
//             }}
//           >
//             <span style={{ minWidth: '0.6in', display: 'inline-block' }}>{label}</span>
//             <span
//               style={{
//                 width: '1in',
//                 borderBottom: '0.3pt solid black',
//                 height: '6pt',
//                 display: 'inline-block',
//               }}
//             />
//           </div>
//         ))}
//       </div>
//     </div>
//   </div>
// );


// qrcode:
// export const BarCodeDiv = ({ value, shortCode }) => (
//   // return (
//   // const codeText = value.split('-')[1];

//      <div
//        id='canvas'
//        style={{
//          width: '0.5in',
//          height: '1in',
//          display: 'flex',
//          flexDirection: 'column',
//          alignItems: 'center',
//          justifyContent: 'flex-start',
//          paddingTop: '3px',
//          paddingLeft: '1px',
//          paddingBottom: '2px',
//          boxSizing: 'border-box',
//        }}
//      >
//        {/* Increase QR code size to 68px */}
//        <QRCode value={value} size={80} />
//        <small
//          style={{
//            fontSize: '10px',
//            margin: '0',
//            fontWeight: 700,
//            color: '#000',
//            textAlign: 'center',
//            lineHeight: '1',
//          }}
//        >
//       {value.split('-')[1]}
//        </small>
//        <p
//          style={{
//            fontSize: '10px',
//            margin: '1px 0 0 0',
//            fontWeight: 700,
//            color: '#000',
//            textAlign: 'center',
//            lineHeight: '1.1',
//          }}
//        >
//          Activation Code
//        </p>
//      </div>
//   //  );
// );




export const BarCodeDiv = ({ value, shortCode }) => (
  <div
  
    style={{
      width: "1in",
      height: "0.5in",
      display: "flex",
      alignItems: "center",
      gap: "4px",
      fontFamily: "Arial, sans-serif",
      boxSizing: "border-box",
      padding: "0.03in",
      marginRight: "0.2in",
        pageBreakAfter: "always",
      // border:'1px solid red'
    }}
  >
    {/* QR Code */}
    <div
      style={{
        width: "0.45in",
        height: "0.45in",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <QRCode value={shortCode} size={40} />
    </div>

    {/* Value Text */}
    <p
      style={{
        fontSize: "6pt",
        margin: 0,
        lineHeight: "1.1",
        wordBreak: "break-all",
      }}
    >
      {value}
    </p>
  </div>
  // <div
  //   // 1 wi 0.5 height wq : 
  //   style={{
  //     width: '1in',
  //     height: '0.5in',
  //     position: 'relative',
  //     fontFamily: 'Arial, sans-serif',
  //     boxSizing: 'border-box',
  //     padding: '0.05in',
  //     marginRight: '0.4in', // <-- adds horizontal space between barcodes
  //     // display: 'inline-block', // <-- ensures divs align side-by-side
  //     display: 'flex', // <-- ensures divs align side-by-side
  //     justifyContent:'center'  // both qr and value in a row btn little distance

  //   }}
  // >
  //   <div
  //     style={{
  //       width: '0.5in',
  //       height: '0.5in',
  //       display: 'flex',
  //       flexDirection: 'column',
  //       justifyContent: 'flex-start',
  //       alignItems: 'center',
  //     }}
  //   >
  //      <QRCode value={value} size={80} />
     
  //   </div>
  //   <p style={{ fontSize: '6pt', margin: '3px 0 4px', lineHeight: '1.2' }}>{value}</p>

    
  // </div>
);


